import React from 'react'
import Main from './main/Main'
import Header from './header/Header'
import Aside from '../../shared/Aside'

function Home() {
    return (
        <>
            <Header />
            <Main />
            <Aside />
        </>
    )
}

export default Home